import { useState, useCallback } from 'react';

interface UseFormCheckboxProps {
    name: string;
    initialValue?: boolean;
    onFirstTouch?: (name: string) => void;
}

interface UseFormCheckboxReturn {
    value: boolean;
    dirty: boolean;
    touched: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: () => void;
}

const useFormCheckbox = ({ name, initialValue = false, onFirstTouch }: UseFormCheckboxProps): UseFormCheckboxReturn => {
    const [value, setValue] = useState<boolean>(initialValue);
    const [dirty, setDirty] = useState<boolean>(false);
    const [touched, setTouched] = useState<boolean>(false);

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (!touched) {
                setTouched(true);
                onFirstTouch?.(name);
            }
            setValue(e.target.checked);
            setDirty(false);
        },
        [touched, onFirstTouch, name]
    );

    const handleBlur = useCallback(() => {
        setDirty(true);
    }, []);

    return {
        value,
        dirty,
        touched,
        onChange: handleChange,
        onBlur: handleBlur,
    };
};

export default useFormCheckbox;
